/* eslint-disable no-unused-vars */
import { Search, Separator } from 'components';
import { useSignal } from '@preact/signals-react';
import { Search as SmallSearchIcon } from 'assets/icons';
import { useEffect, useId, useRef } from 'react';

export const SearchSection = ({ showSelectedApps$, searchValue$ }) => {
  const searchId = useId();
  const searchRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        containerRef.current &&
        !e.target?.closest('.ChooseAppSection') &&
        !containerRef.current.contains(e.target)
      ) {
        showSelectedApps$.value = true;
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <div
        style={{
          height: '48px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Search
          value={searchValue$.value}
          onChange={(e) => {
            searchValue$.value = e.target.value;
          }}
          ref={searchRef}
          id={searchId}
          placeholder='Search Application'
          rightIconOnClick={() => (searchValue$.value = '')}
          Icon={SmallSearchIcon}
          onFocus={() => {
            showSelectedApps$.value = false;
          }}
        />
      </div>
      <Separator width='calc(100% + 48px)' marginLeft={-24} />
    </div>
  );
};
